import ActiveArtistRedirection from "./ActiveArtistRedirection";
export default ActiveArtistRedirection;
